import styled from 'styled-components/macro'

const Wrapper = styled('div')`
  height: 100%;
  padding-bottom: 72px;
`

export default Wrapper
